import { translate, translateRich, useLocale } from "../../localization";
// ActivityStream.js
import React, { useMemo } from "react";
import "./ActivityStream.scss";

export default function ActivityStream({ sessions = [], limit = 20 }) {
  const locale = useLocale();
  const recentActivity = useMemo(() => {
    if (!sessions || sessions.length === 0) return [];

    return sessions
      .map(s => ({
        sessionCode: s.sessionCode || s.code,
        timestamp: new Date(s.startTime || s.timestamp),
        score: s.meanScore,
        responseCount: s.responseCount,
      }))
      .filter(a => !isNaN(a.timestamp.getTime()))
      .sort((a, b) => b.timestamp - a.timestamp)
      .slice(0, limit);
  }, [sessions, limit, locale]);

  const getIcon = (score) => {
    if (score >= 80) return "🟢";
    if (score >= 60) return "🟡";
    return "🔴";
  };

  const formatTimeAgo = (date) => {
    const seconds = Math.floor((new Date() - date) / 1000);
    if (seconds < 60) return translate("{value0}s ago", {
  value0: seconds
});
    if (seconds < 3600) return translate("{value0}m ago", {
  value0: Math.floor(seconds / 60)
});
    if (seconds < 86400) return translate("{value0}h ago", {
  value0: Math.floor(seconds / 3600)
});
    return translate("{value0}d ago", {
  value0: Math.floor(seconds / 86400)
});
  };

  return (
    <div className="activityStream">
      {recentActivity.map((activity, idx) => (
        <div key={`${activity.sessionCode}-${idx}`} className="activity-item">
          <span className="activity-icon">{getIcon(activity.score)}</span>
          <div className="activity-content">
            <div className="activity-text">{translateRich("{value0} completed {value1} insight{value2}{value3}", {
  value0: <strong>{activity.sessionCode}</strong>,
  value1: activity.responseCount,
  value2: activity.responseCount !== 1 ? "s" : "",
  value3: activity.score != null && <span className="activity-score">{translateRich(" \xB7 {value0}% avg", {
      value0: Math.round(activity.score)
    })}</span>
})}</div>
            <div className="activity-time">{formatTimeAgo(activity.timestamp)}</div>
          </div>
        </div>
      ))}

      {recentActivity.length === 0 && (
        <div className="activity-empty">{translate("No recent activity")}</div>
      )}
    </div>
  );
}